export default {
  prevSlideText: {
    id: 'hub_buying_guide_slider_prev_slide',
    defaultMessage: 'Display previous slide',
  },
  nextSlideText: {
    id: 'hub_buying_guide_slider_next_slide',
    defaultMessage: 'Display next slide',
  },
}
